/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';

export const listReviewerReviewedClipsV1QuerySchema = z.object({
  userId: z.string().min(1),
  action: z.enum(['approved', 'rejected']),
  limit: z.coerce.number().int().min(1).max(60).default(12),
  offset: z.coerce.number().int().min(0).default(0),
});

export type IListReviewerReviewedClipsV1Query = z.input<
  typeof listReviewerReviewedClipsV1QuerySchema
>;
